import Modal from '@ui/Modal/component'
import initSelectCustom from '@ui/SelectCustom/component'

export default function (): void {
  if (document.getElementById('search-around-link')) {
    const modalEl = document.getElementById('modal-search-around') as HTMLElement
    const modal = Modal(modalEl)

    const distanceSelectEl = modalEl.querySelector<HTMLDetailsElement>('details.o-select-custom')

    if (distanceSelectEl) {
      initSelectCustom(distanceSelectEl)
    }

    document.querySelectorAll('.search__around-link').forEach((el) => {
      el.addEventListener('click', (e) => {
        e.preventDefault()
        modal.open()
      })
    })

    document.getElementById('search-around-button')?.addEventListener('click', function () {
      const autocompleteFieldEl = document.getElementById('search_offers_autocomplete_autocomplete') as HTMLInputElement
      const searchAroundFieldEl = document.getElementById('search-around-value') as HTMLInputElement
      const searchOffersMaxDistanceEl = document.getElementById('search-offers-maxDistance') as HTMLSelectElement

      autocompleteFieldEl.value = searchAroundFieldEl.value
      searchOffersMaxDistanceEl.value = (document.getElementById('search_offers_maxDistance') as HTMLSelectElement).value
      // close modal before submitting or the select won't be part of the form when the form is submitted
      modal.close()
      document.getElementById('search_offers_search')?.click()
    })
  }
}
